module.exports = __webpack_public_path__ + "img/rotate-arrow-to-the-right.2b4e12a4.svg";